import styled from "styled-components";

export const HomeBalanceContainer = styled.span`
  display: flex;
  flex-direction: row;
  padding-top: 10px;
`;

// export const HomeBox = styled.div`
//   width: 100%;
//   height: auto;
//   border-radius: 10px;
//   border: 1px solid #e8eaed;
//   box-shadow: 0px 4px 4px 0px #e9e9e940;
//   padding: 20px;
//   cursor: pointer;
//   @media only screen and (max-width: 767px) {
//     display: inline-block;
//     width: 100%;
//   }
// `;

export const HomeBox = styled.div`
  width: 15rem;
  height: auto;
  border-radius: 10px;
  border: 1px solid #e8eaed;
  box-shadow: 0px 4px 4px 0px #e9e9e940;
  padding: 20px;
  cursor: pointer;
  transition: border-color 0.3s;
  &:hover {
    border-color: #00a603;
  }
  @media only screen and (max-width: 767px) {
    display: inline-block;
    // width: 100%;
  }
`;

export const HomeBoxImg = styled.div`
  width: 49px;
  height: 49px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ccf4cd99;
`;

export const HomeP01 = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
`;

export const HomeAmount = styled.span`
  font-family: Inter;
  font-size: 30px;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: 0.5px;
  text-align: left;
  font-family: GT Walsheim Pro;
  font-size: 30px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: left;
`;

export const HomeSpan = styled.span`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.02em;
  color: #09005b;
  margin: 0;
`;

export const HomeBoxContainer = styled.div`
  // // align-items: center;
  // gap: 20px;
  // width: 100%;
  // margin: 20px;
  // background: blue;

  display: flex;
  flex-direction: row;
  width: 100%;
  /* height: 265px; */
  height: auto;
  flex-shrink: 0;
  gap: 20px;
  border-radius: 10px;
  margin: 0px;
  // border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);

  @media only screen and (max-width: 767px) {
    // width: 100%;
    display: flex;
    flex-direction: row;
    overflow-y: auto;
  }
`;

export const HomeBoxImg01 = styled.div`
  width: 49px;
  height: 49px;
  border-radius: 8px;
  background-color: #ceccde99;
`;

export const SmallZero = styled.span`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  line-height: 34px;
  letter-spacing: 0.5px;
`;

export const HomeBoxWrapper = styled.div`
  margin-top: 30px;
  @media only screen and (max-width: 767px) {
    margin-top: 10px;
  }
`;
